// utils
import { _val } from 'app/utils';
import { applySuggestScheduling } from 'app/components/modals/pad-editor/prescriptionModal/prescriptionForms/utils/applySuggestScheduling';

export const prescriptionDietInitFormFn = (values = {}) => {
  values = applySuggestScheduling(values);

  return {
    calendarType: _val(values.calendarType, null),
    frequencyAmount: _val(values.frequencyAmount, null),
    frequencyTypeId: _val(values.frequencyTypeId, null),
    suggestScheduling: _val(values.suggestScheduling, null),

    // "a cada"
    firstApplicationDate: _val(values.firstApplicationDate, null),
    firstApplicationTime: _val(values.firstApplicationTime, null),

    // "vezes por dia - hor. esp."
    applicationTimes: _val(values.applicationTimes, []),

    // "vezes por dia - por turno"
    perDayPerShifts: _val(values.perDayPerShifts, []),

    // "vezes por semana"
    daysOfWeek: _val(values.daysOfWeek, []),
    // "vezes por semana - por turno"
    perWeekPerShift: _val(values.perWeekPerShift, null),
    // "vezes por semana - hor. esp."
    perWeekSpecificTime: _val(values.perWeekSpecificTime, null),

    // "vezes por mês - hor. esp."
    perMonthSpecificTime: _val(values.perMonthSpecificTime, null),
    perMonthSpecificTimeDates: _val(values.perMonthSpecificTimeDates, []),

    // "vezes por mês - por turno"
    perMonthPerShiftDates: _val(values.perMonthPerShiftDates, []),
    perMonthPerShift: _val(values.perMonthPerShift, null),

    scheduleType: _val(values.scheduleType, null),
    dose: _val(values.dose, null),
    administrationRouteId: _val(values.administrationRouteId, null),
    diluentId: _val(values.diluentId, null),
    diluentDose: _val(values.diluentDose, null),
    asNeeded: _val(values.asNeeded, null),
    continuousUse: _val(values.continuousUse, 1),
    period: _val(values.period, null),
    justification: _val(values.justification, null),
    instruction: _val(values.instruction, null),

    alertMessageFrequency: _val(values.alertMessageFrequency, {}),

    // professional prescriptor
    professionalId: _val(values.professionalId, null),
    responsibleForPrescription: _val(values.responsibleForPrescription, {}),
    alertMessage: _val(values.alertMessage, {}),

    formAddOn: {
      diluent: _val(values.diluent, {}),
      unity: _val(values.unity, {}),
      administrationRoute: _val(values.administrationRoute, {}),
      professional: _val(values.professional, {})
    }
  };
};
